import { getField, updateField } from 'vuex-map-fields';
import DeviceService from '../../services/DeviceService';
import Device from '../../models/Device';
import moment from 'moment';

export default {
	state: {
		devices: [],
		selectedDeviceId: null,
		activatedDialog: false
	},

	getters: {
		getField,

		activeDevices: (state, getters) => {
			return getters.devices
				.filter(device => device.is_registered)
				.filter(device => !! device.activated_at)
				.filter(device => !! device.latest_state);
		},

		inactiveDevices: (state, getters) => {
			return getters.devices.filter(device => !device.is_registered);
		},

		devices: state => state.devices
			.map(device => new Device(device)),

		devicesByAccuracy: state => state.devices
			.map(device => new Device(device))
			.sort((a, b) => {
				if (a.getAccuracy() > b.getAccuracy()) return -1;
				if (a.getAccuracy() < b.getAccuracy()) return 1;
				return 0;
			}),

		device: (state) => {
			const deviceData = state.devices
				.find(device => device.id === state.selectedDeviceId);

			return deviceData ? new Device(deviceData) : null;
		},
	},

	actions: {
		resetDevices({ commit }) {
			commit('resetDevices');
		},
		async loadDevices({ commit }) {
			try {
				const deviceData = await DeviceService.getDevices();
				commit('devices', deviceData);
				return deviceData;
			} catch(e) {
				throw e;
			}
		},
		updateDevice({ commit }, payload) {
			return DeviceService.updateDevice(payload.id, payload.data)
				.then((device) => {
					commit('updateDevice', device);
				})
				.catch((e) => {
					throw e;
				});
		},
		async selectDevice({ commit }, deviceId) {
			commit('selectDevice', deviceId);

			const device = await DeviceService.getDevice(deviceId)

			// if(!device.latest_state) throw Error('No locations available for this Device');

			commit('updateDevice', device);

			return device;
		},
		async switchDevice({ commit }, deviceId) {
			commit('selectDevice', deviceId);
			const device = await DeviceService.getDevice(deviceId)

			commit('updateDevice', device);

			return device;
		},
		deselectDevice({ commit }, deviceId) {
			commit('deselectDevice', deviceId);
		},
		setStateOfDevice({ commit, getters }, index) {
			if (!getters.device) return;

			// eslint-disable-next-line
			const device = getters.device;
			let stateIndex = index;

			if (device.states.length === 0) return;
			if (stateIndex >= device.states.length) stateIndex = device.states.length - 1;
			if (stateIndex < 0) stateIndex = 0;

			commit('updateDevice', { ...device, stateIndex });
		},

		setStateOfDeviceByDate({ dispatch, getters }, date) {
			if (!getters.device) return;

			const device = getters.device;

			let stateIndex = 0;
			let state = device.states[stateIndex];

			for (stateIndex in device.states) {
				state = device.states[stateIndex];
				if (date.diff(moment.utc(state.send_at).local()) >= 0) break;
			}

			if (stateIndex == getters.device.stateIndex) {
				if (date.diff(device.getLastUpdate()) < 0) {
					return dispatch('prevStateOfDevice');
				}
				return dispatch('nextStateOfDevice');
			}

			return dispatch('setStateOfDevice', Number(stateIndex));
		},

		prevStateOfDevice({ dispatch, getters }, speed = 1) {
			if (!getters.device) return;
			const stateIndex = getters.device.stateIndex + speed;
			dispatch('setStateOfDevice', stateIndex);
		},
		nextStateOfDevice({ dispatch, getters }, speed = 1) {
			if (!getters.device) return;
			const stateIndex = getters.device.stateIndex - speed;
			dispatch('setStateOfDevice', stateIndex);
		},

		disableHistoryMode({ dispatch }) {
			dispatch('setStateOfDevice', null);
		},
		enableHistoryMode({ dispatch }) {
			dispatch('setStateOfDevice', 0);
		},
	},

	mutations: {
		updateField,
		devices(state, deviceData) {
			state.devices = deviceData;
		},
		updateDevice(state, device) {
			const devices = [...state.devices];
			devices[devices.findIndex(element => element.id === state.selectedDeviceId)] = device;
			state.devices = devices;
		},
		selectDevice(state, deviceId) {
			state.selectedDeviceId = deviceId;
		},
		deselectDevice(state) {
			state.selectedDeviceId = null;
		},
		resetDevices(state) {
			state.devices = [],
				state.selectedDeviceId = null;
		},
		showActivatedDialog(state) {
			showActivatedDialog: true;
		},
		hideActivatedDialog(state) {
			showActivatedDialog: false;
		}
	},
};
